import React, { ReactElement } from 'react';
import ChampFormulaire from '../../Common/ChampFormulaire';
import { FormulaireCreationEntite, PropsDeCreationEntite } from '../Utils/FormulaireCreationEntite';
import { JourneePedagogique } from '../../../../../common/src/entities';
import { LABEL_COL } from '../constantes';

export function ChampsJourneePedagogique(): ReactElement {
    return (
        <>
            <ChampFormulaire labelCol={LABEL_COL} type="date" id="date" titre="Date" estPetit />
            <ChampFormulaire
                id="type_flottant"
                titre="Type"
                suggestions={['F1', 'F2', 'F3', 'F4', 'Flottante']}
                isCreatable
                labelCol={LABEL_COL}
                estPetit
            />
            <ChampFormulaire labelCol={LABEL_COL} id="notes" titre="Notes" textarea />
        </>
    );
}

export default function CreerJourneePedagogique(
    props: Partial<PropsDeCreationEntite<JourneePedagogique>>,
): ReactElement {
    return (
        <FormulaireCreationEntite
            texteEntete={(t: JourneePedagogique) => (
                <>
                    <small className="text-muted">Modifier</small>&nbsp;{'La date'}
                </>
            )}
            entite={JourneePedagogique}
            noSave
            {...props}
        >
            <ChampsJourneePedagogique />
        </FormulaireCreationEntite>
    );
}
